import { Table, TableContainer } from "@mui/material";
import Scrollbar from "src/components/Scrollbar";
import { useGetDemoExRequest } from "src/services/admin/queries/demos";

import SkeletonTable from "../../DemoTable/SkeletonTable";
import TableNotFound from "../../DemoTable/TableNotFound";
import TableBody from "./TableBody";
import TableHeader from "./TableHeader";

// ----------------------------------------------------------------------

type Props = {
	email: string;
};

export const DemoTable = ({ email }: Props) => {
	const { data, isFetching, isError } = useGetDemoExRequest(email);

	const empty = data?.length === 0 || isError;

	return (
		<Scrollbar sx={{ maxHeight: 500 }}>
			<TableContainer>
				{isFetching && <SkeletonTable />}
				{!isFetching && data && (
					<Table size='small'>
						<TableHeader />
						<TableBody data={data} />
						{empty && <TableNotFound />}
					</Table>
				)}
			</TableContainer>
		</Scrollbar>
	);
};

export default DemoTable;
